import styled, { css } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

import { StyledBottomNavBar } from '../../AnimatedNavBar/AnimatedNavBar.styles';

export const StyledBottomNav = styled(StyledBottomNavBar)<{
  visible: boolean;
}>`
  inset: auto 0 0 0;
  transform: ${({ visible }) => `translateY(${!visible ? '100%' : '0'})`};
`;

export const StyledFullScreenModeWrapper = styled.div`
  display: none;
  ${({ theme }) => css`
    @media (min-width: ${theme.Screen.Size.Medium}px) {
      display: flex;
      justify-self: flex-end;
    }
  `};
`;

export const StyledFlexBox = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => utils.rem(theme.Sizes.Large)};
`;

export const StyledLeftFlexBox = styled(StyledFlexBox)`
  grid-row: 1;
  grid-column: 1;
  ${({ theme }) => css`
    @media (max-width: ${theme.Screen.Size.Large}px) {
      grid-rows: 2;
    }
  `};
  justify-content: left;
`;

export const StyledRightFlexBox = styled(StyledFlexBox)`
  grid-row: 1;
  grid-column: 3;
  ${({ theme }) => css`
    @media (max-width: ${theme.Screen.Size.Large}px) {
      grid-rows: 2;
    }
  `};
  justify-content: right;
`;

export const StyledZoomControllerWrapper = styled.div`
  ${({ theme }) => css`
    @media (max-width: ${theme.Screen.Size.Medium}px) {
      display: none;
    }
  `};
`;

export const StyledButtonSize = styled.div`
  //TODO: this is not the best solution, but it works for now, we need to handle size changes properly
  & .ant-dropdown-trigger,
  & .ant-dropdown-trigger div {
    height: ${({ theme }) => utils.rem(theme.Sizes.X4Large)} !important;
  }
  & button {
    height: ${({ theme }) => utils.rem(theme.Sizes.X4Large)} !important;
  }
  & button {
    height: ${({ theme }) => utils.rem(theme.Sizes.X4Large)} !important;
  }
`;

export const StyledVideoControllerWrapper = styled.div`
  flex: 1;
  grid-column: 2;
  ${({ theme }) => css`
    @media (max-width: ${theme.Screen.Size.Large}px) {
      grid-row: 2;
      grid-column: 1/4;
    }
  `};
`;
